import { render, staticRenderFns } from "./FundTransaction.vue?vue&type=template&id=4ab7bf66&scoped=true&"
import script from "./FundTransaction.vue?vue&type=script&lang=js&"
export * from "./FundTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab7bf66",
  null
  
)

export default component.exports